module.exports = __webpack_public_path__ + "img/house-church-walk_b2.473dad6a.jpg";